import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isMduEnabled } from './mdu-feature.helper';

export const mduEnabledGuard: CanActivateFn = (route) =>
  isMduEnabled() ||
  inject(Router).createUrlTree([
    '/installation-reporting',
    route.params['ifs'],
  ]);
